<template>
    <div class="w-screen bg-gray-100">

        <FlashMessages></FlashMessages>
        
        <gmap-map
            ref="mapRef"
            :center="{lat:driver.lat, lng:driver.lng}"
            :options="{mapTypeControl: false, streetViewControl: false, styles: styles}"
            :zoom="12"
            map-type-id="terrain"
            :style="{width: '100%', height: height}"
        >

            <template v-if="selected_delivery">
                <gmap-marker
                    :position="selected_delivery.customer.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="user"

                    @click="selectDelivery(null)"
                />
                <gmap-marker
                    :position="selected_delivery.restaurant.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="merchant"

                    @click="selectDelivery(null)"
                />
            </template>
            <template v-else>
                <gmap-marker
                    :key="`customer_${index}`"
                    v-for="(m, index) in deliveries"
                    :position="m.customer.position"
                    :clickable="true"
                    :draggable="false"
                    :label="marker_label(m)"
                    :icon="marker_icon(m)"
                    @click="selectDelivery(m)"
                />
            </template>


        </gmap-map>


        <div v-if="selected_delivery" class="" >


            <div
                style="text-shadow: 0px 0px 2px rgba(255, 255, 255, 1)"
                class="inline-block align-bottom bg-white bg-opacity-80 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                
                <div class="w-full flex">
                    <div class="flex-1">
                        <span class="font-bold text-sm">{{ selected_delivery.order_id }}</span>
                    </div>
                    <div>
                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">{{ status_names[selected_delivery.status] }}</span>
                    </div>
                </div>
                
                
                <div class="mt-2">


                    <nav aria-label="Progress">
                        <ol class="overflow-hidden">
                            <li class="relative pb-10">
                                <div :class="(selected_delivery.status==='pending'||selected_delivery.status==='grabbed')?'bg-gray-300':'bg-indigo-600'" class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full " aria-hidden="true"></div>
                                <!-- Restaurant -->
                                <div class="relative flex items-start group">
                                    <span class="h-9 flex items-center">
                                        
                                      <span v-if="selected_delivery.status === 'pending'" class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400">
                                        <span class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"></span>
                                      </span>
                                      <span v-else-if="selected_delivery.status ==='grabbed'" class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-indigo-600 rounded-full">
                                        <span class="h-2.5 w-2.5 bg-indigo-600 rounded-full"></span>
                                      </span>
                                      <span v-else class="relative z-10 w-8 h-8 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800 text-white">
                                          <IconCheckSolid size="5"></IconCheckSolid>
                                      </span>
                                    </span>
                                                                <span class="ml-4 min-w-0 flex flex-col">
                                      <span class="text-xs font-semibold tracking-wide uppercase text-indigo-600">{{ selected_delivery.restaurant.name }}</span>
                                      <span class="text-sm text-gray-500">{{ selected_delivery.restaurant.address }}</span>
                                    </span>
                                </div>
                            </li>

                            <li class="relative pb-10" v-if="selected_delivery.status !=='pending' && selected_delivery.status !== 'grabbed'">
                                <div class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                <!-- Current Step -->
                                <div class="relative flex items-start group" aria-current="step">
                                    <span class="h-9 flex items-center" aria-hidden="true">
                                      <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-indigo-600 rounded-full">
                                        <span class="h-2.5 w-2.5 bg-indigo-600 rounded-full"></span>
                                      </span>
                                    </span>
                                    <span class="ml-4 min-w-0 flex flex-col">
                                      <span class="text-xs font-semibold tracking-wide uppercase text-indigo-600">{{ status_names[selected_delivery.status] }}</span>
                                      <span class="text-sm text-gray-500"> {{ selected_delivery.timepreparing }} minutes </span>
                                    </span>
                                </div>
                            </li>

                            <li v-else class="relative pb-10">
                                <div class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                <!-- Current Step -->
                                <div class="relative flex items-start group" aria-current="step">
                                    <span class="h-9 flex items-center" aria-hidden="true">
                                      <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400">
                                        <span class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"></span>
                                      </span>
                                    </span>
                                    <span class="ml-4 min-w-0 flex flex-col">
                                      <span class="text-xs font-semibold tracking-wide uppercase text-indigo-600">${{ selected_delivery.earning.toFixed(2) }}</span>
                                      <span class="text-sm text-gray-500">{{ selected_delivery.distance }}</span>
                                    </span>
                                </div>
                            </li>

                            <li class="relative">
                                <!-- Upcoming Step -->
                                <div class="relative flex items-start group">
        <span class="h-9 flex items-center" aria-hidden="true">
          <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400">
            <span class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"></span>
          </span>
        </span>
                                    <span class="ml-4 min-w-0 flex flex-col">
          <span class="text-xs font-semibold tracking-wide uppercase text-indigo-600">{{  selected_delivery.customer.address }}</span>
          <span class="text-sm text-gray-500">
              <template v-if="selected_delivery.status !=='pending' && selected_delivery.status !== 'grabbed' ">
                  {{ selected_delivery.distance }} <IconArrowRightSolid size="3"></IconArrowRightSolid> ${{ selected_delivery.earning.toFixed(2) }}
              </template>
              
          </span>
        </span>
                                </div>
                            </li>

                        </ol>
                    </nav>
                    

                </div>

                <div v-if="selected_delivery.status==='pending'" class="mx-4 mt-2 text-xs text-left">

                    <div class="mb-2">En saisissant cette commande, je m'engage en tant que service de courrier de:</div>

                    <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Ramasser la commande dans des délais de 10-15 minutes après sa préparation</div></div>
                    <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Livrer la commande dans des délais raisonnables pour assurer la fraîcheur des aliments</div></div>
                    <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Communiquer avec un gérant si je ne peux respecter les points ci-hauts</div></div>
                    <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Être courtois avec les restaurateurs, et la clientèle.</div></div>

                </div>
                
                <div class="mt-5 sm:mt-6">
                    <template v-if="selected_delivery.status === 'pending'">
                        <button @click="conf" type="button"
                                :class="confirming?'bg-indigo-800':'bg-indigo-600'"
                                class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                            <template v-if="confirming">
                                Confirmer saisie?
                            </template>
                            <template v-else>
                                Saisir commande
                            </template>
                        </button>
                    </template>
                    <inertia-link v-else :href="selected_delivery.link"
                                  class="bg-indigo-600 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                        Voir commande
                    </inertia-link>

                    <button @click="selectDelivery(null)" type="button"
                            class="mt-2 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-gray-300 text-base font-medium text-gray-900 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:text-sm">
                        Annuler
                    </button>
                </div>


                <p v-if="selected_delivery.status === 'pending'" class="px-2 my-4 text-xs italic">Advenant le non-respect des termes ci-hauts, je m'expose à un bris d'entente qui pourrait engendrer la suspension de la relation facturable avec LIVRO.CA INC. et retirer la capacité de réserver des quarts de livraison.</p>

            </div>

        </div>
        
    </div>
</template>

<script>



import user from "../../../images/user.png";
import user_red from "../../../images/user-red.png";
import merchant from "../../../images/merchant.png";
import FlashMessages from "../../Shared/FlashMessages";
import PhoneFormatter from "../../Shared/PhoneFormatter";
import IconCheckOutline from "../../../icons/outline/IconCheckOutline";
import IconCheckSolid from "../../../icons/solid/IconCheckSolid";
import IconArrowRightSolid from "../../../icons/solid/IconArrowRightSolid";
import RoutePlotter from "../../Shared/lib/RoutePlotter";
import userMapStyles from "../../../v2/js/V2/lib/userMapStyles";
export default {
  name: "Map",
    props: ['driver', 'extras'],
    components: {IconArrowRightSolid, IconCheckSolid, FlashMessages, PhoneFormatter, IconCheckOutline},
    data() {

        
        return {
            user: user,
            user_red: user_red,
            merchant: merchant,
            height: window.innerHeight + "px",
            deliveries: [],
            selected_delivery: null,
            confirming: false,
            grabbing: false,
            
            previous_bounds: null,
            first_launch: true,
            lines: [],

            ready: false,
            status_names: {
                pending: 'En Attente',
                grabbed: 'Saisie',
                preparing: 'En Préparation',
                ready: 'Pret',
                canceled: 'Annulée',
                pickedup: 'Picked Up',
                delivered: 'Livrée',
                undelivered: 'Non-Livrée'
            },

            styles: userMapStyles
        }
    },

    async mounted() {
        await this.$gmapApiPromiseLazy();
        this.ready = true;
        this.load();
        setInterval(()=>{
            this.load();
        }, 60 * 1000); // reload it every minute?
    },
    
    
    methods: {
      load() {
          window.axios.post(this.$route('driver.map.json', {driver_id: this.driver.id}), this.extras).then(response => {
              
             this.deliveries = response.data;
             if (this.first_launch) {
                 this.first_launch = false;
                 this.center();
             }
             if (this.selected_delivery) {
                 this.selected_delivery = this.deliveries.filter(d => d.id === this.selected_delivery.id).shift();
             }
          });
      },

        center() {
          if (this.deliveries.length === 0) {
              return;
          }
            if (this.$refs.mapRef) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    
                        let bounds = new google.maps.LatLngBounds();
                        this.deliveries.forEach(delivery => {
                            bounds.extend(delivery.customer.position);
                            bounds.extend(delivery.restaurant.position);
                        })
                        map.fitBounds(bounds);
                    
                });
            }
        },
        selectDelivery(delivery) {

          this.confirming = false;
        this.lines.forEach(line => line.setMap(null));
        this.lines = [];
          this.selected_delivery = delivery;

          this.height = delivery ? "200px" : window.innerHeight + "px";

        if (this.$refs.mapRef) {
            this.$refs.mapRef.$mapPromise.then((map) => {
                if (delivery) {
                    this.previous_bounds = {
                        center: map.getCenter(),
                        zoom: map.getZoom()
                    }
                    

                    if (delivery.routing) {                         
                        // const polyUtil = require('polyline-encoded');
                        if (delivery.routing.routes.length === 0 || delivery.routing.routes[0].legs.length === 0) {
                            return;
                        }
                        this.lines = RoutePlotter(delivery.routing.routes[0].legs[0].steps, map)
                        // delivery.routing.routes[0].legs[0].steps.forEach(step => {
                        //     const points = polyUtil.decode(step.polyline.points).map(group => { return {lat: group[0], lng: group[1]}});
                        //     const line = new google.maps.Polyline({
                        //         path: points,
                        //         geodesic: true,
                        //         strokeColor: "#FFFF00",
                        //         strokeOpacity: 1.0,
                        //         strokeWeight: 2,
                        //     });
                        //     line.setMap(map);
                        //     this.lines.push(line);
                        //    
                        // })

                    }

                    let bounds = new google.maps.LatLngBounds();
                    bounds.extend(delivery.customer.position);
                    bounds.extend(delivery.restaurant.position);
                    map.fitBounds(bounds);

                    
                } else {
                    
                    map.setCenter(this.previous_bounds.center);
                    map.setZoom(this.previous_bounds.zoom);
                    
                }
                
            });
        }
          
          
          
          
        },
        conf() {
            if (this.confirming) {
                if (this.grabbing ) {
                    return;
                }
                this.grabbing = true;
                let route = this.$route("driver.delivery.grab", {driver: this.driver.id, delivery: this.selected_delivery.id});
                window.axios.post(route, {json: true, ...this.extras}).then(response => {
                    if (response.data.error) {
                        // TODO: flash it.
                    }
                    this.grabbing = false;
                    this.load();
                });
            } else {
                this.confirming = true;
            }
        },

        marker_label(delivery) {
            if (delivery.status !== 'pending') {
                return null;
            }
            return {text:`${delivery.placedtime}`, color: '#ffffff', fillColor: '#0000ff'};
        },
        marker_icon(delivery) {
            if (delivery.status === 'pending') {
            //    return null;
            }

            let color = '#60A4B9';
            switch(delivery.status) {
                case 1: 
                    color = '#4CAF50';
                    break;
                case 2:
                    color = '#D6DD5E';
                    break;
                case 3:
                    color = '#538C87';
                    break;

                case 4: // picked up
                    color = '#60A4B9';
                    break;

                case 0:
                    if (delivery.placedtime > 50) {
                        color = '#ff0000';
                    } else if (delivery.placedtime > 15) {
                        color = '#DF5141';
                    }
                    break;
            }
            
            
            return {
               path: "M18.1422 16.1421L12.2843 22L6.42637 16.1421C5.26781 14.9835 4.47882 13.5074 4.15918 11.9004C3.83953 10.2934 4.0036 8.62774 4.63062 7.11399C5.25764 5.60025 6.31945 4.30643 7.68179 3.39614C9.04413 2.48586 10.6458 2 12.2843 2C13.9227 2 15.5244 2.48586 16.8868 3.39614C18.2491 4.30643 19.3109 5.60025 19.9379 7.11399C20.565 8.62774 20.729 10.2934 20.4094 11.9004C20.0897 13.5074 19.3007 14.9835 18.1422 16.1421ZM12.2843 12.1251C12.7725 12.1251 13.2408 11.9312 13.586 11.5859C13.9313 11.2407 14.1252 10.7724 14.1252 10.2842C14.1252 9.79595 13.9313 9.3277 13.586 8.98245C13.2408 8.63721 12.7725 8.44325 12.2843 8.44325C11.796 8.44325 11.3278 8.63721 10.9825 8.98245C10.6373 9.3277 10.4433 9.79595 10.4433 10.2842C10.4433 10.7724 10.6373 11.2407 10.9825 11.5859C11.3278 11.9312 11.796 12.1251 12.2843 12.1251Z",
                fillColor: color,
                fillOpacity: 1,
                anchor: new google.maps.Point(
                    14, // width
                    14 // height
                ),
                strokeWeight: 1,
                strokeColor: "#ffffff",
                scale: 1.5,
            };
            
        },
    }
}
</script>

<style scoped>

</style>
